// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_refis_refis_module_ts":"637325cb3a04662a","src_app_features_contador_contador_module_ts":"08175cfff2f0a1ad","src_app_features_to-legal_to-legal_module_ts":"53ae5fc13b94dd8d","src_app_features_cadastro_produtor-rural_acompanhamento_acompanhamento_module_ts":"127c634e3e859c78"}[chunkId] + ".js";
};